module.exports = __webpack_public_path__ + "img/elem_fire.5d67e2d3.svg";